import { render } from "./LastSales.vue?vue&type=template&id=1fac18c7&scoped=true"
import script from "./LastSales.vue?vue&type=script&lang=js"
export * from "./LastSales.vue?vue&type=script&lang=js"

import "./LastSales.vue?vue&type=style&index=0&id=1fac18c7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fac18c7"]])

export default __exports__